import type { FeatureStateSnapshot } from "./FeatureStateTypes";

export class FeatureStateStore {
  private snapshot: FeatureStateSnapshot = {
    activeFeatureId: null,
    featureCountRemaining: null,
    featureAccumulatedWinMinor: null,
  };

  private readonly listeners = new Set<(snapshot: FeatureStateSnapshot) => void>();

  public getSnapshot(): FeatureStateSnapshot {
    return this.snapshot;
  }

  public isFeatureActive(): boolean {
    return this.snapshot.activeFeatureId !== null;
  }

  public setActiveFeature(input: {
    featureId: string;
    featureCountRemaining?: string | null;
    featureAccumulatedWinMinor?: string | null;
  }): void {
    this.snapshot = {
      activeFeatureId: input.featureId,
      featureCountRemaining: input.featureCountRemaining ?? null,
      featureAccumulatedWinMinor: input.featureAccumulatedWinMinor ?? null,
    };
    this.emit();
  }

  public updateProgress(input: {
    featureCountRemaining?: string | null;
    featureAccumulatedWinMinor?: string | null;
  }): void {
    if (!this.snapshot.activeFeatureId) {
      return;
    }

    this.snapshot = {
      ...this.snapshot,
      featureCountRemaining:
        input.featureCountRemaining !== undefined
          ? input.featureCountRemaining
          : this.snapshot.featureCountRemaining,
      featureAccumulatedWinMinor:
        input.featureAccumulatedWinMinor !== undefined
          ? input.featureAccumulatedWinMinor
          : this.snapshot.featureAccumulatedWinMinor,
    };
    this.emit();
  }

  public clear(): void {
    this.snapshot = {
      activeFeatureId: null,
      featureCountRemaining: null,
      featureAccumulatedWinMinor: null,
    };
    this.emit();
  }

  public subscribe(listener: (snapshot: FeatureStateSnapshot) => void): () => void {
    this.listeners.add(listener);
    listener(this.snapshot);
    return () => this.listeners.delete(listener);
  }

  private emit(): void {
    for (const listener of this.listeners) {
      listener(this.snapshot);
    }
  }
}